import HomePayFeeFormOnRamp from "../forms/HomePayFeeFormOnRamp";
import {AvailableBalance} from "../../utils/creditService";

interface HomePayFeeModalViewOnRampProps {
  onCloseModal: () => void;
  handleBack: () => void;
  creditLine: AvailableBalance;
}

function HomePayFeeModalViewOnRamp(
  {
    onCloseModal,
    handleBack
  }:HomePayFeeModalViewOnRampProps) {

  return (
    <HomePayFeeFormOnRamp
      onCloseModal={onCloseModal}
      handleBack={handleBack}/>
  );
}

export default HomePayFeeModalViewOnRamp;